import step1Image from "../../../assets/images/featureDiscovery/editOrder/step1.svg";
import step2Image from "../../../assets/images/featureDiscovery/editOrder/step2.svg";
import step3Image from "../../../assets/images/featureDiscovery/editOrder/step3.svg";
import { FeatureDiscoveryTour } from "../types";

export const editOrderTour: FeatureDiscoveryTour = {
  featureKey: "edit_order",
  title: "Make corrections to a submitted order",
  badgeLabel: "New",
  helpTitle: "Edit Submitted Orders",
  slides: [
    {
      id: "action-bar",
      image: step1Image,
      imageAlt: "Edit-order action bar shown on hover in the Orders tab",
      body: (
        <>
          <p>
            You can now edit demographic information in submitted orders within
            a 12-hour window.
          </p>
          <p>
            <strong>How it works:</strong> hover over any row in the Orders tab
            to reveal the action bar, then click Edit. If the button is
            disabled, the edit window has closed. A tooltip will alert you when
            time is running out.
          </p>
        </>
      ),
    },
    {
      id: "review-step",
      image: step2Image,
      imageAlt: "Edit-order form with the remaining edit window in the header",
      body: (
        <p>
          You&apos;ll see all the editable fields. Just click on what needs
          correction and then save changes. The header shows your remaining edit
          time. You can make changes as many times as needed within the window.
          <br />
          The save changes button becomes active when a change is made.
        </p>
      ),
    },
    {
      id: "edited-badge",
      image: step3Image,
      imageAlt: "Updated order badge tooltip on the Orders tab",
      body: (
        <p>
          Once saved, the order is marked with an &apos;Updated&apos; badge.
          Hover to see a summary of who made the last edit and when.
        </p>
      ),
    },
  ],
};
